import { SvgBase } from "../svg.base";

export const Profile = () => (
  <SvgBase
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <path
      fill="currentColor"
      d="M15 15c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    />
  </SvgBase>
);